import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_12'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_12',
  name: 'Does the facility have any of the following safety measures in place related to laser/radiation equipment?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'LASER_RADIATION_EQUIPMENT_IS_MAINTAINED_AND_REGULARLY_INSPECTED',
      text: 'Laser/radiation equipment is maintained and regularly inspected',
      externalIds: [
        {
          id: 'hs-32--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'LASER_RADIATION_EQUIPMENT_HAVE_THE_APPROPRIATE_PROTECTION',
      text: 'Laser/radiation equipment have the appropriate protection',
      externalIds: [
        {
          id: 'hs-32--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'LASER_RADIATION_EQUIPMENT_HAS_THE_APPROPRIATE_SIGNS',
      text: 'Laser/radiation equipment has the appropriate signs',
      externalIds: [
        {
          id: 'hs-32--2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WORKING_WITH_RADIATION_SOURCES_ARE_PROTECTED_AND_NOT_EX',
      text: 'Workers working with radiation sources are protected and not exposed to more than three rems/year',
      externalIds: [
        {
          id: 'hs-32--2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_THAT_WORK_WITH_LASER_RADIATION_PRODUCING_EQUIPMENT_UNDE',
      text: 'Workers that work with laser/radiation-producing equipment understand why and how to operate the equipment safely',
      externalIds: [
        {
          id: 'hs-32--2-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-32--2-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'LASER_RADIATION_EQUIPMENT_IS_MAINTAINED_AND_REGULARLY_INSPECTED',
                'LASER_RADIATION_EQUIPMENT_HAVE_THE_APPROPRIATE_PROTECTION',
                'LASER_RADIATION_EQUIPMENT_HAS_THE_APPROPRIATE_SIGNS',
                'WORKERS_WORKING_WITH_RADIATION_SOURCES_ARE_PROTECTED_AND_NOT_EX',
                'WORKERS_THAT_WORK_WITH_LASER_RADIATION_PRODUCING_EQUIPMENT_UNDE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-wor-3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15940,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
